var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.067,
    height: 61.316,
    viewBox: "0 0 65.067 61.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -14.759)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.715,61.677,40.73,19.425a9.532,9.532,0,0,0-16.393,0L1.353,61.677a9.527,9.527,0,0,0,8.195,14.4H55.519A9.529,9.529,0,0,0,63.715,61.677ZM32.534,68.45a3.813,3.813,0,1,1,3.813-3.813A3.817,3.817,0,0,1,32.534,68.45ZM36.346,53.2a3.813,3.813,0,0,1-7.625,0V34.137a3.813,3.813,0,1,1,7.625,0Z",
    transform: "translate(0 -14.759)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.09c9317c4d0dbe6f483459247f2edbd4.svg";
export { ForwardRef as ReactComponent };